import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QltsUserController from "../../../../services/qlts/qlts-user-controller";

class ModalAddPaymentCLBN extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customerId: "",
            childName:"",
            money: "",
            content: '',
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.state = {
                customerId: nextProps.info?.customerId,
                childName:nextProps.info?.childName,
                money: "",
                content: '',
            };
        }
    }
    createCustomerPayment = () => {
        let money = parseInt(this.state.money.toString().replaceAll(",", ""))
        if (isNaN(money)){
            toast.warning("Tiền không đúng định dạng!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let payload = {
                customerId: this.state.customerId,
                paymentReq: {
                    content: this.state.content,
                    money: money,
                }
            }
            QltsUserController.customerPayment(payload, res => {
                if (res.success) {
                    toast.success("Thêm hóa đơn thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    });
                    this.props.onHide();
                    this.props.onRefresh()
                } else {
                    toast.warning(res.message[0], {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
            })
        }

    }
    formatMoney(num) {
        num = num.toString().replaceAll(",", "")
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm giao dịch nộp tiền</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Số tiền nộp(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="Nhập số tiền nộp"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.formatMoney(this.state.money)}
                                        onChange={(event) => {
                                            this.setState({
                                                money: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Ghi chú</label>
                                    <input
                                        placeholder="Ghi chú"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.content}
                                        onChange={(event) => {
                                            this.setState({
                                                content: event.target.value
                                            })
                                        }}
                                    />
                                </div>

                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.createCustomerPayment()}
                                >
                                        <span className='justify-content-center'>
                                            Tạo
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalAddPaymentCLBN
